<template>
  <div v-if="!!entry">
    <StandardEntry v-if="!singleEntryComponentName" :entry="entry" />
    <component v-elfe :is="singleEntryComponentName" :entry="entry" />
  </div>
  <Pagination
    v-else
    :current-page="1"
    :component-name="listEntryComponentName || 'StandardEntry'"
    data-attribute-name="entry"
    :data-list="dataList"
    :entries-per-page="3"
    :key-function="item => item.id"
  />
</template>

<script>
import Pagination from './Pagination.vue';
import { urlify } from '../util';

export default {
  name: 'SingleEntryOrList',
  props: {
    dataList: {
      type: Array,
      required: true,
    },
    singleEntryComponentName: {
      type: String,
    },
    listEntryComponentName: {
      type: String,
    },
  },
  data: () => ({
    entry: null,
  }),
  methods: {
    updateEntry(route) {
      const { title } = route.params;
      if (!title) {
        this.entry = null;
      } else {
        this.entry = this.dataList.find(entry => urlify(entry.title) === title);
      }
    },
  },
  created() {
    this.updateEntry(this.$route);
  },
  watch: {
    $route(to, from) {
      this.updateEntry(to);
    },
  },
  components: { Pagination },
};
</script>

<style scoped></style>
